import axios from 'axios'
import { baseURL, patientBffBaseURL } from 'config'

export const apiClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' }
})

export const patientBffApiClient = axios.create({
  baseURL: patientBffBaseURL,
  headers: { 'Content-Type': 'application/json' }
})

apiClient.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('default_auth_token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

apiClient.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response.status === 401) {
      logout()
    }
    return Promise.reject(error)
  }
)

function logout() {
  localStorage.removeItem('isAdminToken')
  localStorage.removeItem('default_auth_token') // clear admin token
  window.location = `${window.location.origin}/login` // we clear the whole state of all micros
}
export default apiClient
